<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="con"></a>Contents</h1>
<p class="toc"><a href="#/05_introduction#intro"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/06_partone#one">Part One: UFOs</a></p>
<p class="toc"><a href="#/07_chapter01#c1">1. UFOs and the Cold War</a></p>
<p class="toc"><span href="#/08_chapter02#c2" title="Link target outside of Sample">2. A Chronology of Doubt</span></p>
<p class="toc"><span href="#/09_chapter03#c3" title="Link target outside of Sample">3. Low, Big, and Slow: The End of Doubt</span></p>
<p class="toc1"><span href="#/10_parttwo#two" title="Link target outside of Sample">Part Two: Extraterrestrials</span></p>
<p class="toc"><span href="#/11_chapter04#c4" title="Link target outside of Sample">4. Humanoids</span></p>
<p class="toc"><span href="#/12_chapter05#c5" title="Link target outside of Sample">5. Abductions: The Index Case—Barney and Betty Hill</span></p>
<p class="toc"><span href="#/13_chapter06#c6" title="Link target outside of Sample">6. Abductions: The Touchstone Cases</span></p>
<p class="toc"><span href="#/14_chapter07#c7" title="Link target outside of Sample">7. The Abduction Narrative</span></p>
<p class="toc1"><span href="#/15_partthree#three" title="Link target outside of Sample">Part Three: Us</span></p>
<p class="toc"><span href="#/16_chapter08#c8" title="Link target outside of Sample">8. What We Know</span></p>
<p class="toc"><span href="#/17_chapter09#c9" title="Link target outside of Sample">9. Science and UFOs</span></p>
<p class="toc"><span href="#/18_chapter10#c10" title="Link target outside of Sample">10. Extraterrestrial Politics</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/19_acknowledgments#ack" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="toc"><span href="#/20_notes#note" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/21_readings#read" title="Link target outside of Sample"><i>Selected Readings</i></span></p>
<p class="toc"><span href="#/22_index#ind" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?67c640df